import {TfSpiceService} from './tf-spice.service';


export const TfSpiceInjectables: Array<any> = [
  {provide: TfSpiceService, useClass: TfSpiceService},
];
